import { useCallback } from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";

import BookYogaNutritionTrialForm from "../BookYogaNutritionTrialForm";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./BookYogaNutritionTrialModal.module.scss";

interface BookYogaNutritionTrialModalProps {}

const BookYogaNutritionTrialModal: React.FC<
  BookYogaNutritionTrialModalProps
> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { showBookYogaNutritionTrialModal } = useAppSelector(
    (state) => state.bootCamp
  );

  const setShowBookYogaNutritionTrialModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookYogaNutritionTrialModal(value));
    },
    [dispatch]
  );

  return showBookYogaNutritionTrialModal ? (
    <ModalMotion
      overlayClosable
      onClose={() => setShowBookYogaNutritionTrialModal(false)}
      width="520px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={cls("bookYogaNutritionTrialModal")}
    >
      <BookYogaNutritionTrialForm showModal={showBookYogaNutritionTrialModal} />
    </ModalMotion>
  ) : (
    <></>
  );
};

export default BookYogaNutritionTrialModal;
